// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ExpandableClamp__label":"bcb_a bib_hi bib_sa bib_xl"};